"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    OverlayInput: ()=>OverlayInput
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const index_cjs_namespaceObject = require("../../IconButton/index.cjs");
const external_InputText_index_cjs_namespaceObject = require("../../InputText/index.cjs");
const external_OverlayInput_variants_cjs_namespaceObject = require("./OverlayInput.variants.cjs");
function OverlayInput({ label, backIconName = 'arrow_back', handleInputTextChange, handleClose }) {
    const { root, icon, input } = (0, external_OverlayInput_variants_cjs_namespaceObject.overlayInputVariants)();
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
        className: root(),
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                className: icon(),
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.IconButton, {
                    iconName: backIconName,
                    type: "plainPrimary",
                    shadow: true,
                    size: "sm",
                    "aria-label": "Close Drawer",
                    onClick: handleClose
                })
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_InputText_index_cjs_namespaceObject.InputText, {
                className: input(),
                size: "md",
                iconLeft: "search",
                isInset: !!label,
                label: label,
                onChange: handleInputTextChange
            })
        ]
    });
}
exports.OverlayInput = __webpack_exports__.OverlayInput;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "OverlayInput"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
